// Pick random mint
const mintedTokens = ["0x8cbdf697a85d1393a5f074c74bdab2965a323d0314281c8f11c8b33f7f772503","0xf7a1661dad065148c95558492586232469bf04533f71e324f65c6cfbe2546c92","0xd1759f17a3b7240dba1417de30ec4d857ecbc648f7e6e28e13582d3713e2dcbb","0x8ee647e2df3d69abd1c60ef9900bf62b6ca978bae7e34b5a23e2cd1a89cd2e59","0x10779e8824b292e21722b0b0aa68d91fb6520db01d65db27288cdb4b2acfeb33","0x11841e050bd603a56ddfa9f74b35ffa27157f3151b650edc2ed50b908b1dd359","0xf581f1f94e2e6b8533f13be78c6d1837fef057e41620ffeae8f8c7f5d02c1d4a","0x876f5a47f17a35b21cb100397e730be027ea8a4643150dec82891193d866eefa","0xf1f2969f531123ee4a6ad4a773697127c6242a688c8056ce3d027c5cdd9e9c8d","0x27bcecbc3dddfd7336d9f2ae29349254ea241718c44abbfa0b2bc8ecae0d85a4","0x80747bbb9e7f86f647a9eb5ee9fd82046fa96295f2fd751a300b479ee6136e94","0xabb36127ce3deb8338c6e5cf77230e79d8b96e1376f190620b768063be1d1529","0x9a879af59d1db80d1bad7ef2f49e267e3ca3000193a4d1690861c0a663da403a","0x1c6b41dcf0d30d0afdaf3ee6a46767bab2ae57e16f5d0f76e241e0c0cb917ec7","0xbd05ed13a5984ac636f7934aa36626c0dc4710daa8cbaa602b6cff25c5611cae","0xce0cac7a769d5781f1be72c6eddb9ad89f4729472ddbdc3c1733b0a111c32756","0x649490fe2e174255886ac8906b4fc88f36da0f3a03c88c1704a9ec43d5eedd66","0xc6c7d42bc23dad7c18f76f69070d08aeb72e7167bf5fc62ad5f2feba550fb6f4","0xd1d299c99b924770ef77085461a30760dabfdce101e9a2f4f691be3bb41b8e9e","0x758478e79b0769ac4cd170f3f88b19c0667bfc50fab777ddb921560343a4ad51","0x81d3ddbcf7b6589af1f470b3a369237a06e8fa7cdfd92e997d6451a846af2593","0x1ed5265e74abb1b8112ab0e7b8d1f83e7c156ce07dbe48ee3fe9ccca1625eeaf","0x5527ad0ec24afa8e5fc7897a6d60f86a774c65cff3e84b96db96ec3dd00c1c3e","0xa566dbc8529542b6fb474b3d366be3c90c0b123537c22909a2282edf8a0b3f66","0xc248f38635af4b7e530e587f39c7a47992da0973f347a7f7072aef77677479fa","0x77fa1aa4e01f859da79391fbe2369a27103b334cee55691c63582735ea14ae18","0xdab9256e484e4e87fa5ddbba5634c4d4e1e4a4c93e84decd74bcdb9c8378940d","0xf1db329f2990f3a4cfc535a5aa2d7f2a250061cdfe7b86f275ba200b3b8b8660","0xbf33d596b2beba9bcbf7700c506933f69dcf52e6ead514969bcb2eb4fe37251c","0xc96161d5d9023bf28df29a317deac4b69e2ac8ad880c4bb462824a88c77bdf61","0x86a729c853b27a3807429c05a79a94d66a5a2b0eca1ceb5f608a56118aca379e","0xf3ac85cae69848203d1c0a0b1c5ad1bf5554b7c4fb40151f7d0f06bcf2bd4948","0x7e9ceb1786c1ad5b62de92482b67d3a77e8f2b49c1d68490f6571a6bbe1e5f0f","0x2b3dbbe00571d09b2dfb6ec7805562e96c2717687908426c757bc05f97036411","0x79dcb6898c2a4fbcb578de3e3a41960587635bf7ce28a3ae0a46620680532825","0xb454566864acb9cd2d6c56eaf58471dc5f2e7f66301aa3254717d3e9e9fa9153","0xe455d8d2d15748725c3f0867e510bd569b24d7adf17ad0b9871ae1c076e49037","0xe65bdbb33a58786330ff5a1ddbd73af11225819a20b6719b703428d859992cb4","0x79da01e7ac68ae391160fdb0cfd6dfe4e71b8b511f4e4f154a565f4cd83dfbff","0x553462d6a7e17783562bfd8150bccea863ad8d75a49878fb5c92eaa9b5e0af0e","0x8817658fb0fb594c7b361a66049ce453b979822f9bd63e82eb8a2e2bf2e31fab","0xe8dac6bb789256ddfa47bdf103615be22feff0eee2c78cde317f12335a74d2da","0x1e255328c20f034acc35695182de91fc6d9345265a528cafe63e5b4427fc2682","0xfd5b32f50b80abffc35357b2c32b0a33bb0c9d226fc402d0829f1e36a2d7f8c9","0x09a43d898027799cb9bbe4b368a87d7f28075fa6501079f54cd2d1e10d5cdc00","0xff6b006e12f1da3f155cb8bc227ef99eb0ea3d1c3aab3bf5825f1bbdf26b74d7","0xf4086ff75a85c4cdd181b2fa37a4cd1f6f1dfc72968b3296d46e38d086d3ba94","0xf9e1b30edbc7f882918c2ecea0e492c8fd1d3c8047b18fc3861989c66aa41b36","0x2f2274d3b463228a5554fa2e7ae2b9e82f2b43ce26347a04803433de3def71f9","0x7766155f1af47d691d2f9792650cdf6c18b47af575745d04a577eeb0753a6320","0xfc84af8c2b28d6611bd899e7af46d1b63b5836b0aeeecb631c1659b2057d37ca","0x92570e6e8f1adb40a842dfb63fbd9cd5c9b0c650f41f503ecbb6c265e440248d","0xc4fd3490f610b301c901d9d5cf5091e975753e3322a62ed57aa464290bf4261a","0xaeed27dda2ca5d4fb2e9e8e3d2f1c031928f5a2e222ec907872c62b8e9bc103f","0x8452dcb31a014b622d12f8f2881a1c82a0a5263204b841bac81a0604acb92b11","0xc18fd1bc4af31dc1b747ff757635e50300d231d480a7b893f1310d81b5415633","0x3ad975b72f25082dead92b9f3945df4d07ea36041f9cdfb76a35c73dbadcd87f","0xfbc03f228a281c7e39306d0f70049d56cfacfc48e9facd24ce5362974d464df7","0x583a016421eaa98dffb66ae9905995a483f44bae3b648c7b6384797573a68466","0xab461c51296fb1bd6e8cc4765a07b1291875727b124d0ae0d9c64158f70f0599","0x5070a5ebe4e398371a9c252faa3e258cfafcc170c2f8873fe7728bfad2bb09df","0x74fc068c1369452a1c94a15836792990080177941b734a44fa6eebd36a130b4b","0xf8d111ebf7d7547f51cced9e8f789ad499c154c0bf266ab2aaf8b19999ce1c98","0xedcfec8e9dde5962e9d08fe63f5f5cf5ca4826aaf81032154de52e81513c52fd","0x909a93e6d309eaba760f6fe5d4085f26739f38d7ceb35cd4a6ce1972bd3484b1","0x2ebae3d1f8113470a32c6566b4baf313aeff3d9000cd179c52d323d91ae37a62","0xf61b979fe415466706aafa48703740aa28de6bca6eeb84191ade5c4ff0f7b888","0x148e652f6119ae1c3dc9fa2db8ecd3ca778b151e7c49c1a857764497866ea43a","0xb61bf7bd2f56f8def8e1cf8b4ce3ac6fe27b3aabb942aede2fca21894ca5d5b6","0x901db8fa2dec42bfc69c1218a7910ef37973bbfec8c37a4d9f1bb2a8de5010e9","0xe3c3b6f00d293d9b8c6f153babb630c27492438ef47f83d141b73058be6cc134","0xefb69050db2561e5ab2ec9975bf6321b7d1b27a4d25ab3e86b8e09d5005b2c92","0x2b152c379bc2c85d5a8cec9629d993e5411200a068f92cce215ba89e04beaa01","0x87646f0a4fb871cea4c104148c809756deb6f94b756c9f8e4f9d7e230ace27ae","0x0bcbd9db6c5fc61449a13af8cb181770aefcd2ee5de7c866d6b7f90a32f8bf03","0xfdf4a52f1a05485766e2d2318f3b41bdcc83b8bad6d5b3023d73433838a7b605","0x19c5f9d48c24f27e91773dab94e114a7b44e3c82342faf0f59e61f465b521b6c","0x9a1669e904417c7f8922018bdbc734641e204b5e5709df98ad0800d33a9f2b65","0xf2d9ba2dfa4fd1cf1b0bc01d703ff985ca2d2cb6e7129de14c20276c836f4844","0x8cb4539ce70dceeadc6f4e5c1615f6dd73461a0588f193edef08be94abba6d0a","0x465590a16146fc6f6767cf600688fca659e313cfb22bae697fc25ab14f8742c6","0x2a5d52973677b3b370911d042bd4abf06463920a2dd4dcf62eb06c9e13fc0a39","0xb7e2ff705620429c696c88d818ca8042596afac45112dfda3469821768356d1c","0x214dbf7130f3dd27333d9e326bcab80eabea33af4661587d90269e282c96c2ed","0x0e5db0cc9f01b3f16efef809eca0bd74ce0f6364d500551438ef533290f90c0d","0x2a1d3ba9520c477c473d866cf9854df5130460d3b7e6d5d09c6a2f76ecdb8708","0x9b4e0f9536b74620984a5d0f0a222c40142d2b69b064bd447267e199da64e9f8","0x2e32fc6470dafdcaf4614cc471f12f21c5166be52bbeca92846e78dafed13700","0x26909c1cea697379bb8ae45bcfc252d05547ecdece7d12735bbd2f2b9db363ff","0x9560c7193945887b479fd82501a2c99731d2e926473023d32c7ba0c58e8976ce","0xd25b89d0d1c792dd3ffd75843a1aad4ede94d045a6dc075d2590cc501adf2c93","0xdfde766d5e3f615fc1773e7ebeb48763b5dbfa6727b4aceeb4353180cbd1b9dd","0x7ef2b1a203e0e1ec850a434121db670a9a9adfcf43f36c655caa4979eba96732","0x2e478fa7e925d79fa363877247b651a079abfbb5521b18f22b8ac8e78a643d65","0x63f36e75a30ac3d072611ff676b0dfc1f6065d1b1fbd2fc2307f50c5815f408d","0xe8726da6491c2d41fe38629793ada6768a4e06a8f46e2e613d4840cf340ac3f0","0x7b78f2e26d2a972272d911b13f44ff2176cc467f7c0a25d142c0b1ebfc56d852","0xbb7531c1a3c013566ce0386825590bbe8e9732802877608152c8ddaf8d5f5251","0xb500f0ffdfbfafcdd97447770232986304a827124960c0658d4eb56203aa6293","0x3aa52b8c922433819901fecb185ad425a236edc003133c127b2b0def8bdec12d","0xd3778fa76832932b5ee3cd7d343092f1aecc53c7efb7ea0f8a1628ad6b78a9f5","0xb2b48f880589bf8986380fa8d4d9932b5d1f7f6f485a6ebb7495f31c1433fbfa","0x7a797c1081eacdab555df1bd12aa02f85cf91a9b345c89922734534dab6756a4","0x3ab92d87a06ac9160e8944c53079ee3f8308682528032fcf034e8a35cbaf0297","0x04ebd9e856cc3717937b2acb8b665172d362649c66de33bdb12b94bcf3b579c2","0xf8d61e1f3b4d44f5535d53936605cd1fb5f831853b343b2ff753b0f2f50a67f5","0x528df4f718ab19d72a1e384e4f4f2bac7490ca1f23b243db4a6fe4f8c1399668","0xaa246e85d610d869d4205ff8d7f4e96f22acfce42b793f0d59f61256f7430566","0xcb4f49fce9c6028ba9c5882e6e712cfce7fd5d42773fefaafd936200eb559201","0xd3ac68f09ab708abc64686473da873f172cf72b280ba53e15de9ec87b65b48dd","0x639d7770920e4b083332be30ea6a0488549682ca54792a782c6b8fcfac6f0137","0x28a588f9a3fc2239c1ef4d6e391e0f896e28bf28a3bbcf8d315dba97ace5f3ef","0x59254720e01f4289f0f825890ac9652b647d351589191a51ed94006219a2b4c6","0xb9566be9c9e06b1edcb425acacfc1c04a4eec9fce253cc4181efbacf206c65e7","0x09bc0cfe25a4eb665f363d5cbff6860cf42dd07d4815bb50397e8835fc19287f","0xb7c82dd48ec2ebede0067daf741f4ea2ac056630621955e7907b81d9b877646f","0xb13371c00f319799a07391d05bee3afa30e70d5827b61360e47811c2b7f1204d","0xbd3cefa359405af0bcfc2fbc1a026e4df7f89563b27ee853274e5d69b9e556be","0xcc5db19f9e530dff2678b20335d180bd5c90c875c2363fbeaee8ca134c681bfe","0xe11f4508d29e00e2e6eb003c6a255c15a1b26ee4a348aed98dc4c180365404c4","0x2915d49ea45838735550fa81aefe231e757c214be98e75bf230702d0c0e84ab3","0xa6cec4571e6eabdd989ac14413b0e16f9c161864dbf6c2d38a6e2bcf2e02fe22","0x30c6f17fcda99e16adbe0ffb93e7d90c01451c8bd1a65cf52ba062c5f6f2addc","0x7bcf145474d845a0b8f7dabaf65f53c867ee72fb1e63ca5422350c7cfb492d10","0x5179cd90866a6f906815f3d833c4f7d3cd4fedb48a3c0bdaeb0aac43696ae14f","0xc152c0571872dfa6bcb0764cf9d47a2fe4b0bd97d3f413d3d7348500ce4c3dbe","0x0796c376efe9cc1dd599b9900d5e2c91b35c29a9fc2af3b9c7326f714dc274a8","0x412c7f3bfe4ebb2b0e31eccdc20f4714b1a4ba9ad08471c32468d1731c946ec3","0x076088c714e69a0f489451ac430df47c7367ff3be3260ad6f83af201da9c9d18","0x52af84b8076580d416629e9a79154616c1e2758fd15802aff7742a6cb66eeb3a","0xe17e48a11bfafc6e6daa41304829904b9e6339445d584e5933a09f6a119abf23","0xa6b53db0e995226d83b1e4575a8540c13fb63ef8452fec8d3d7a0e703a2c426e","0x70455a1f7159c6545ecf48818d50b3ec37114773305f7e965ae1a843d90fd1c1","0xef50cd16ed1d5503e6cfa38430b298eb7486ef80e401a41c592140bad8a76cfe","0xf7a8a2dde70d71cca362202af29f81481b0d551ac297102989fb816a8eedd4ed","0x6c80d5a11b03073191794ab5e4cabf2b4a84eaf9db22de65050e5d906b1c630e","0xfeb47001c2d1f6ffcd7284aea91b0f7bd0be35314159644c109329f129ce60fb","0x8f17ac0d0e89ec4d8bac6f0c89e03fcb8eb75e9ec62a9b0c0da0099c801e49ac","0x9ee0f44d91057d4fe7f5a560fd69cc1f1a454fe931577c5fcc8e52d65a136de1","0x177829b64f9a8e377e09c2eb13fbb1d88979d5950536b714fc72a2c1b784ffdb","0x8fc78917163e2c46bc318ee2b3c23bbeb9a776aaa1dbdb4240e6152ec906da5a","0xdc47008e33a357bddb1b00956551b01aaa6d234329a2d6c0c8ddf7642696ab68","0xc7df77a65eaa1f13d56b6cd8cb356f10798269f71f50b291502c2791f50585a5","0x49d4415efe8a524118f6bc498c1d9905d8d73d065f0f340b9368a7a20ac8ce82","0x6a912ca8098585818966621d1591967ae6a17d74a6c0e8743ec79c1f13f86d65","0x1e31da3be88aaf7269c460b0fe892c9235b1bdc32c083bcf82231fe3754ec16e","0xce63e66eaaee70ea63b4fe00b9e3a88d3a3d5e3d7aa2ae30f3f3c0ce36911188","0xcf7ea98f92acd5ff75afcdd1aed1e6270e1f30b65f03809960fa72d29b1be4f0","0x1ed1fdf83afa7cd36eaa63639d3cd97b29793676efae148fb9ecb1817faf1cd0","0xf24d739599049b19d55e4ade25b6f3232e11f067a5fdb422b9af379382ae3734","0xfa22b3c81c57afdd6d9af8c96ed43409a614185edc5eec62b42317a664228c2d","0x0caaf452a7f91ad8ff645853a8c9eb8419a75acd968bf11b51939f5ade460d45","0x5a5aacd9f7498081e275c2cd8414c20b9dee9b9e51163f669d8a4f55f40bb432","0x32fb2d665be34b0d0ae6cc5ce74ca8228983c130e2f1b7e4e04d3c11af6fef05","0x8fe03a48f21bf09d93fa2e0143960a30a4ef91956fbdb7ba35d9cb8bd2bf181e","0x098f06ee5d36a9157afe09042ca893f58a88b53473ad6d02e6b25c8a154262e0","0xab9637630910766c2d7e8832fe1fa0c94a7cea3c750933e47cc82d963e253830","0x32974438ba5c35fe853e6a0954cb1f38e43cf77e2cb1506d77ebfdb41a0134c6","0x07a8e72b55e029199c247429a1c82f6583df1edf6200eeb6b929b1b8b0a6e64c","0xa9156bf5cc76c2718fe48f3f91c1075e9eefe0cbc533a65aaeb42b2fde6f16f8","0xc33b3146fe9b2125dd2d4906bb6307e2dfde661a7611803f9925ac003dd2201b","0x305b7b6d72896f20a061b3dadc873bb030ff5b24f07438f2569883b68f80bc65","0x4fde0d6767397325d4b9d0da0b822e25fd0d76ecfee51876bb836ce9a5b7df91","0x32c36b3f54ad9c05f83516a2681f04743504207052e9216597be794051301774","0xa10d4e90af4c0c1ce1243deb0ab7fd47f1aee63c76a65a7c657dc7aec4e4ffe3","0xa58e8bf0b31ed8864d68ae6601b6293ef48e845c602d32d374bbfd93cdf1e775","0x446aa51046c194f22615f2711f518d362038f72a0ce8f6b3950374e847de277d","0xc2b05e99945404a172f5388e054dabafcbced613e34ef690018da283234f8214","0xfe99af0778b4457e3e29b456a9e393075ae160698f8dc714f8ab320732e924c6","0xbfae387d845ebd6d4ea88052f7bd3f7fd8b77d654f039b6e5df67f0997665266","0xf9161816f4ea1eb05eba6fc87eb3c317410942832407ec8a5a3b26da899a1cf7","0x42a3d053ffebc91c023ae9531d6fd8852190683a16c9be87fa6b76ea72ea7730","0x11a2dd7e1fdc142354614c5f26f5247e6dc99cc1a281b373a5fec8170698adc7","0xd99d66f60efa15f42311de129914b6aa62f4711bf3ff867d4bef8c075a1ace2d","0x2a882751f1bc8436a1424164227eb8a36a3ac9b7ab172c620523217c3d890526","0x64609be552914c8d476ee8bd3e5480c8d47b0d509757633f836fecec607aa9cc","0xacb0e612afb7147eacba4bd84260f3961861803beb57656c097505129b23bc89","0xf6e4a22d89a23f5d0682a514fdbebc375f42e53f5c718cd59bec44a3920aa834","0xa87bb3203efd85973e202a39876e2731765f35f70eee41b0b3153a0c2e4262d1","0x29c4aac31990fe53649d9b0d6694cf28c3db228067b8f41bcfc52c68462e8966","0x0e4de0f97a9408a48dfc1b588baa7baba152a26f08c564996e959a691f2bbb23","0x1469b8e8bb625c713fd078ab4eb8ff74bb3b5acd84eebd1a631171ee731eaa1e","0xd7b91db13f27cc3ed12057a4776d63ccfe57a8c163eaa502ad17205085ecd83e","0xc34ae2b82b4d6b3eca496831b74241391f48c0eff9f9cb3dc6ca78bf7199e15d","0x5b2bc65c9f8c43f4511148dcb9dbd7672b2d466644c6d39d66ddfaba59a8d0cf","0x09afef3fd4becc9379253205511b1b5405ca21357d78a1da5b68ec1274cb101f","0xcae20c904e94d05d53d2d49dc9a5e4803d2f021ef7a2d494337fb9a804aaefb9","0x59bde94eec6f1ee87c0edc29e453d22ba4979f64951dfc64dc73b4b93823aec1","0x161a34b01ad476c7619f985d77cf399fc54a9bad4aec8c4f4662ddb8cb2bbba5","0xeb533024713b5c6870db87a2edec36b537f65550eff3f32e2c31215be514032a","0x08617723cf4119a9b6f9f52cb497368ffe5b532a8b19e25bc2836bbfce8edb04","0x87ba33451fa4302f56bfe4d99bb8fff604dfa886afabe1fca5a70f995d52a5ff","0x7404bf88561b51d8295ca86d719d30f3f14376f01387b0d3a30a43c38c3412f0","0xd15e03291971dda9dc263f4d5734537678238784165a984ce70cb3e696f0dc3e","0xf1d939ff60b40ea2c4ebf9e4b7af138756f2fb92b3020aaf900297f0c131b3f8","0x43425c5f1f74d640abc03b8954e2f65caba7e9cb3471df7de81928baebb020be","0x9733542d06f1cf346edd75f7acc4ad8b5849c0c87a0b7040a13d512d029deb09","0xf9750ec3381fd37288c4d9be8557467988e2fba45465b3330d22ab6bce45bbc9","0x12fe6c6e6c4eec056820a21f4c3fbdd08dd1f9d89ee9b8d5470a13a0a7162353","0xad1d7d8bccaf9ddf7137853b21ba638ac5ec133fd9e55412975e074e0b9b8a24"]
const randomMint = Math.floor(Math.random() * mintedTokens.length);
window.tokenData = {
  tokenId: 343000000 + randomMint,
  hash: mintedTokens[randomMint]
};

// Output mint ID being used
const mintIdText = document.getElementById('mintId');
mintIdText.innerHTML = randomMint;

import Random from './Random';
import Easing from './easing';
import Algorithms from './Algorithms';

// Init vars
const R = new Random();
window.R = R;
let timer = 0;
const blockAspectRatio = Math.sqrt(2);

/**
 * Inverts an eased number on 1 axis.
 *
 * @param {Float} easedValue
 * @returns Inverted eased number
 */
function invertEasing(easedValue) {
  return (easedValue + 0.5) % 1;
}

//
// Params
//
const params = {
  seed: 0,
  speed: 0.0,
  algorithm: 0,
  gridCount: 0,
  easing: 0,
  rotationX: 0,
  rotationY: 0,
  rotationZ: 0,
  modifierA: 0,
  modifierB: 0,
  modifierC: 0,
  modifierD: 0,
  chaos: false,
  invert: false,
};

window.grid = {
  border: {
    x: 75,
    y: 0
  },
  size: {},
  block: {
    border: {},
    size: {}
  }
};

const defaultWidth = 1280;
const defaultHeight = 720;

function calculateCanvasSize() {
  const canvasAspectRatio = defaultWidth / defaultHeight;
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight * 0.9;

  // Wider than tall
  if (windowHeight < windowWidth / canvasAspectRatio) {
    return {
      w: windowHeight * canvasAspectRatio,
      h: windowHeight
    };
  }
  else {
    return {
      w: windowWidth,
      h: windowWidth / canvasAspectRatio
    }
  }
}


/**
 * P5 setup
 */
window.setup = () => {
  const canvasSizing = calculateCanvasSize();
  const canvas = createCanvas(canvasSizing.w, canvasSizing.h, WEBGL);
  canvas.parent('canvas');

  perspective(PI / 3.0, width / height, 0.1, 1000);
  pixelDensity(2);

  // Params setup
  params.seed = R.random_num(0, 10000);
  params.speed = R.random_num(0.004, 0.008);

  params.algorithm = floor(Easing.InQuad(R.random_dec()) * Algorithms.length);

  let pickGridSize = Easing.InOutQuad(R.random_dec());
  pickGridSize = invertEasing(pickGridSize);
  pickGridSize = round(pickGridSize * 55 + 9);
  params.gridCount = pickGridSize;
  if (R.random_num(0, 100) < 1) {
    params.gridCount = R.random_int(3, 6);
  }

  params.easing = R.random_int(0, Object.keys(Easing).length - 1);

  params.rotationX = TWO_PI; // Must always be TWO_PI to avoid gimbal lock
  params.rotationY = R.random_choice([0, PI, TWO_PI]);
  params.rotationZ = 0;
  if (R.random_int(0, 50) < 1) {
    params.rotationZ = R.random_choice([0, PI, TWO_PI]);
  }

  params.modifierA = R.random_dec();
  params.modifierB = R.random_dec();
  params.modifierC = R.random_dec();
  params.modifierD = R.random_dec();

  // Calculate grid
  calculateGrid();
}


/**
 * P5 draw tick
 */
window.draw = () => {
  randomSeed(params.seed);

  // Stlying
  background(29);
  stroke(39);
  fill(249);
  if (params.invert) {
    stroke(249);
    fill(29);
  }

  // Set world position
  translate((width * -0.5) + grid.block.border.x, (height * -0.5) + grid.block.border.y);

  // Render grid
  for (let x = 0; x < grid.x; x++) {
    for (let y = 0; y < grid.y; y++) {
      // Pure chaos
      if (params.chaos) {
        magic(x, y);
      }

      // Styling
      if (params.gridCount > 40) {
        strokeWeight(1.5);
      }
      else if (params.gridCount < 10) {
        strokeWeight(10.5);
      }
      else {
        strokeWeight(3.5);
      }
      push();

      // Position in grid
      translate(x * grid.size.x, y * grid.size.y);

      // Rotate block to face viewport
      rotateX(HALF_PI);

      // Apply the magic
      magic(x, y);

      // Draw the block
      box(grid.block.size.x, grid.block.size.x * 0.2, grid.block.size.y);
      pop();
    }
  }

  // Timer
  timer += params.speed;
}


/**
 * Calculate algorithm.
 *
 * @param {float} x
 * @param {float} y
 */
function magic(x, y) {
  // Calculate cells value
  const modifiers = {
    a: params.modifierA,
    b: params.modifierB,
    c: params.modifierC,
    d: params.modifierD
  }
  let val = Algorithms[params.algorithm](x, y, timer, modifiers);

  // Normalise
  val = abs(val);
  val = val % 1;

  // Apply easing
  const easedValue = pickEasing(val);

  // Pick rotation amount
  rotateX(easedValue * params.rotationX);
  rotateY(easedValue * params.rotationY);
  rotateZ(easedValue * params.rotationZ);
}


function pickEasing(v) {
  return Easing[Object.keys(Easing)[params.easing]](v);
}

/**
 * Calculate Grid
 */
function calculateGrid() {
  // Calculator grid size & alignment
  grid.border.x = width * (grid.border.x / defaultWidth);
  grid.x = params.gridCount;
  grid.border.y = grid.border.x / blockAspectRatio;
  // Grid cell size
  grid.size.x = (width - grid.border.x) / (grid.x + 1);
  grid.size.y = grid.size.x * blockAspectRatio;
  // Grid Y count
  grid.y = max(floor((height - grid.border.y) / grid.size.y), 1);

  // Block size & border
  grid.block.border.x = grid.size.x + grid.border.x / 2;
  grid.block.border.y = (grid.size.y * 0.5) + ((height - (grid.size.y * grid.y)) * 0.5);
  grid.block.size.x = grid.size.x * 0.7;
  grid.block.size.y = grid.size.y * 0.7;
}

/**
 * Easter Eggs
 *
 * @param {event} event
 */
window.keyReleased = (event) => {
  switch (event.keyCode) {
    // Save
    case 83:
      save('Balletic-MotusArt-' + tokenData.hash);
      break;

    // Pause
    case 80:

      if (params.speed != 0) {
        // Pause
        params.speedOriginal = params.speed;
        params.speed = 0;
      }
      else {
        // Resumen
        params.speed = params.speedOriginal;
      }
      break;

    // Chaos
    case 67:
      params.chaos = !params.chaos;
      break;

    // Invert
    case 73:
      params.invert = !params.invert;
      break;
  }
}


/**
 * Demo controls
 */
const examples = [
  {
    // 3 blocks (rare)
    speed: 0.005,
    algorithm: 12,
    gridCount: 3,
    easing: 0,
    rotationY: Math.PI,
    rotationZ: Math.PI,
  },
  {
    // Waves
    speed: 0.0054,
    algorithm: 16,
    gridCount: 31,
    easing: 4,
    rotationY: Math.PI,
    rotationZ: 0,
    modifierA: 1,
    modifierB: 0,
    modifierC: 0.3
  },
  {
    // Moving rings
    speed: 0.0048,
    algorithm: 1,
    gridCount: 29,
    easing: 21,
    rotationY: 0,
    rotationZ: 0,
    modifierA: 0.5,
    modifierB: 0,
    modifierC: 0.5,
    modifierD: 0
  },
  {
    // Blobbys
    speed: 0.0049,
    algorithm: 0,
    gridCount: 38,
    easing: 21,
    rotationY: 0,
    rotationZ: Math.PI * 2,
    modifierA: 0.41,
    modifierB: 0.49,
    modifierC: 0.67,
    modifierD: 0
  },
  {
    // Central pulses
    speed: 0.0059,
    algorithm: 6,
    gridCount: 32,
    easing: 3,
    rotationY: 0,
    rotationZ: Math.PI,
    modifierA: 0.77,
    modifierB: 0.58,
    modifierC: 0.7,
    modifierD: 0
  },
  {
    // Sun rays
    speed: 0.0057,
    algorithm: 9,
    gridCount: 52,
    easing: 6,
    rotationY: Math.PI,
    rotationZ: 0,
    modifierA: 0.15,
    modifierB: 0.29,
    modifierC: 1.0,
    modifierD: 0
  },
  {
    // Checkered
    speed: 0.004,
    algorithm: 10,
    gridCount: 13,
    easing: 13,
    rotationY: 0,
    rotationZ: Math.PI
  },
  {
    // Diagonal swipe
    speed: 0.004,
    algorithm: 16,
    gridCount: 25,
    easing: 21,
    rotationY: Math.PI,
    rotationZ: Math.PI,
    modifierA: 0.14,
    modifierB: 0.78,
    modifierC: 0,
    modifierD: 0
  },
  {
    // Squared
    speed: 0.0048,
    algorithm: 29,
    gridCount: 25,
    easing: 20,
    rotationY: Math.PI,
    rotationZ: 0,
    modifierA: 0.66,
    modifierB: 0.83,
    modifierC: 0.43,
    modifierD: 0.21
  },
  {
    // Largest grid
    speed: 0.005,
    algorithm: 2,
    gridCount: 70,
    easing: 6,
    rotationY: 0,
    rotationZ: Math.PI * 2,
    modifierA: 0.79,
    modifierB: 0.12,
    modifierC: 0.34,
    modifierD: 0
  },
  {
    // Runners
    speed: 0.0062,
    algorithm: 24,
    gridCount: 27,
    easing: 14,
    rotationY: Math.PI * 2,
    rotationZ: 0,
    modifierA: 0.8,
    modifierB: 0.12,
    modifierC: 0,
    modifierD: 0
  },

];
window.example = (num) => {
  for (const property in examples[num]) {
    params[property] = examples[num][property];
  }
  calculateGrid();
  window.scroll(0, 0);
}